import { z } from 'zod';
import { cameraSchema, effectSchema, lightingSchema, transitionSchema, typographySchema, } from './cinematic';
import { idSchema } from './common';
export const assetKindSchema = z.enum([
    'image',
    'video',
    'audio',
    'font',
    'gltf',
    'glb',
    'texture',
    'hdri',
    'svg',
    'json',
    'subtitle',
]);
export const assetRefSchema = z.object({
    assetId: idSchema,
    usage: z.string().optional(),
});
export const audioClipSchema = z.object({
    assetId: idSchema,
    start: z.number().min(0).default(0),
    duration: z.number().positive().optional(),
    gain: z.number().min(0).max(1).default(1),
    track: z.enum(['voice', 'music', 'ambience', 'sfx']),
    fadeIn: z.number().min(0).default(0),
    fadeOut: z.number().min(0).default(0),
    loop: z.boolean().default(false),
});
export const shotSchema = z.object({
    id: idSchema,
    start: z.number().min(0),
    duration: z.number().positive(),
    purpose: z.string().optional(),
    emotion: z.string().optional(),
    energy: z.number().min(0).max(1).optional(),
    camera: cameraSchema.optional(),
    subjects: z.array(assetRefSchema).default([]),
    environment: z.array(assetRefSchema).default([]),
    lighting: lightingSchema.optional(),
    effects: z.array(effectSchema).default([]),
    typography: z.array(typographySchema).default([]),
    audio: z.array(audioClipSchema).default([]),
    transition: transitionSchema.optional(),
});
export const sceneSchema = z.object({
    id: idSchema,
    title: z.string().optional(),
    duration: z.number().positive().optional(),
    shots: z.array(shotSchema).min(1),
    transition: transitionSchema.optional(),
    style: z.string().optional(),
});
export const assetSchema = z.object({
    id: idSchema,
    type: assetKindSchema,
    name: z.string(),
    source: z.object({
        kind: z.enum(['file', 'url', 'generated', 'library']),
        path: z.string().optional(),
        url: z.string().optional(),
    }),
    metadata: z.record(z.unknown()).default({}),
});
export const responsiveCompositionSchema = z.object({
    aspect: z.enum(['landscape', 'portrait', 'square']),
    camera: z.string().optional(),
    composition: z.string().optional(),
    typography: z.array(typographySchema).optional(),
});
export const audioTrackSchema = z.object({
    id: idSchema,
    name: z.string(),
    kind: z.enum(['voice', 'music', 'ambience', 'sfx']),
    clips: z.array(audioClipSchema).default([]),
});
export const formatSchema = z.object({
    preset: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    fps: z.number().int().positive(),
});
export const metadataSchema = z.object({
    title: z.string(),
    language: z.string().default('pt-BR'),
    author: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    description: z.string().optional(),
});
//# sourceMappingURL=project.js.map